'use strict';exports.__esModule = true;
var _reduxLoop = require('redux-loop');
var _reactRouterRedux = require('react-router-redux');
var _reduxConnect = require('redux-connect');
var _reduxPagan = require('redux-pagan');
var _reduxForm = require('redux-form');

var _articles = require('./articles');var _articles2 = _interopRequireDefault(_articles);
var _cities = require('./cities');var _cities2 = _interopRequireDefault(_cities);
var _consultation = require('./consultation');var _consultation2 = _interopRequireDefault(_consultation);
var _propertySearch = require('./propertySearch');var _propertySearch2 = _interopRequireDefault(_propertySearch);
var _agencySearch = require('./agencySearch');var _agencySearch2 = _interopRequireDefault(_agencySearch);
var _propertyPins = require('./propertyPins');var _propertyPins2 = _interopRequireDefault(_propertyPins);
var _propertyDetails = require('./propertyDetails');var _propertyDetails2 = _interopRequireDefault(_propertyDetails);
var _manageProperties = require('./manageProperties');var _manageProperties2 = _interopRequireDefault(_manageProperties);
var _messageModal = require('./messageModal');var _messageModal2 = _interopRequireDefault(_messageModal);
var _userAuthentication = require('./userAuthentication');var _userAuthentication2 = _interopRequireDefault(_userAuthentication);
var _publishProperty = require('./publishProperty');var _publishProperty2 = _interopRequireDefault(_publishProperty);
var _mobilesFilters = require('./mobilesFilters');var _mobilesFilters2 = _interopRequireDefault(_mobilesFilters);
var _advancedFilters = require('./advancedFilters');var _advancedFilters2 = _interopRequireDefault(_advancedFilters);
var _mobileHeader = require('./mobileHeader');var _mobileHeader2 = _interopRequireDefault(_mobileHeader);
var _windowDimentions = require('./windowDimentions');var _windowDimentions2 = _interopRequireDefault(_windowDimentions);
var _contactUs = require('./contactUs');var _contactUs2 = _interopRequireDefault(_contactUs);
var _phoneSmsVerification = require('./phoneSmsVerification');var _phoneSmsVerification2 = _interopRequireDefault(_phoneSmsVerification);
var _favoriteProperties = require('./favoriteProperties');var _favoriteProperties2 = _interopRequireDefault(_favoriteProperties);
var _buyMoreQuestions = require('./buyMoreQuestions');var _buyMoreQuestions2 = _interopRequireDefault(_buyMoreQuestions);
var _propertyNotes = require('./propertyNotes');var _propertyNotes2 = _interopRequireDefault(_propertyNotes);
var _realtor = require('./realtor');var _realtor2 = _interopRequireDefault(_realtor);
var _reviewedPins = require('./reviewedPins');var _reviewedPins2 = _interopRequireDefault(_reviewedPins);
var _company = require('./company');var _company2 = _interopRequireDefault(_company);
var _editCompanyByOwner = require('./editCompanyByOwner');var _editCompanyByOwner2 = _interopRequireDefault(_editCompanyByOwner);
var _propertiesAnalytics = require('./propertiesAnalytics');var _propertiesAnalytics2 = _interopRequireDefault(_propertiesAnalytics);
var _reportIssues = require('./reportIssues');var _reportIssues2 = _interopRequireDefault(_reportIssues);
var _saveSearchLocation = require('./saveSearchLocation');var _saveSearchLocation2 = _interopRequireDefault(_saveSearchLocation);
var _myAccount = require('./myAccount');var _myAccount2 = _interopRequireDefault(_myAccount);
var _professionals = require('./professionals');var _professionals2 = _interopRequireDefault(_professionals);
var _payments = require('./payments');var _payments2 = _interopRequireDefault(_payments);
var _shareModal = require('./shareModal');var _shareModal2 = _interopRequireDefault(_shareModal);
var _assetsToDelete = require('./assetsToDelete');var _assetsToDelete2 = _interopRequireDefault(_assetsToDelete);
var _similarProperties = require('./similarProperties');var _similarProperties2 = _interopRequireDefault(_similarProperties);
var _projectProperties = require('./projectProperties');var _projectProperties2 = _interopRequireDefault(_projectProperties);
var _receiveSuggestions = require('./receiveSuggestions');var _receiveSuggestions2 = _interopRequireDefault(_receiveSuggestions);
var _searchAddressLocus = require('./searchAddressLocus');var _searchAddressLocus2 = _interopRequireDefault(_searchAddressLocus);
var _placesGeocode = require('./placesGeocode');var _placesGeocode2 = _interopRequireDefault(_placesGeocode);
var _propertyTypes = require('./propertyTypes');var _propertyTypes2 = _interopRequireDefault(_propertyTypes);
var _homePageProperties = require('./homePageProperties');var _homePageProperties2 = _interopRequireDefault(_homePageProperties);
var _discountCoupon = require('./discountCoupon');var _discountCoupon2 = _interopRequireDefault(_discountCoupon);
var _notifications = require('./notifications');var _notifications2 = _interopRequireDefault(_notifications);
var _upgradeRegularUserPackage = require('./upgradeRegularUserPackage');var _upgradeRegularUserPackage2 = _interopRequireDefault(_upgradeRegularUserPackage);
var _subscriptions = require('./subscriptions');var _subscriptions2 = _interopRequireDefault(_subscriptions);
var _recentSearches = require('./recentSearches');var _recentSearches2 = _interopRequireDefault(_recentSearches);
var _propertyDetailedForm = require('./propertyDetailedForm');var _propertyDetailedForm2 = _interopRequireDefault(_propertyDetailedForm);
var _contactUsClientForm = require('./contactUsClientForm');var _contactUsClientForm2 = _interopRequireDefault(_contactUsClientForm);
var _foreignPropertyPageProperties = require('./foreignPropertyPageProperties');var _foreignPropertyPageProperties2 = _interopRequireDefault(_foreignPropertyPageProperties);
var _countries = require('./countries');var _countries2 = _interopRequireDefault(_countries);
var _foreignPropertySearch = require('./foreignPropertySearch');var _foreignPropertySearch2 = _interopRequireDefault(_foreignPropertySearch);
var _otherCompanyProperties = require('./otherCompanyProperties');var _otherCompanyProperties2 = _interopRequireDefault(_otherCompanyProperties);
var _leads = require('./leads');var _leads2 = _interopRequireDefault(_leads);
var _contactFormModal = require('./contactFormModal');var _contactFormModal2 = _interopRequireDefault(_contactFormModal);
var _creationNewHomes = require('./creationNewHomes');var _creationNewHomes2 = _interopRequireDefault(_creationNewHomes);
var _myProjects = require('./myProjects');var _myProjects2 = _interopRequireDefault(_myProjects);
var _feedbackIncreaseLimits = require('./feedbackIncreaseLimits');var _feedbackIncreaseLimits2 = _interopRequireDefault(_feedbackIncreaseLimits);
var _incrementPhoneClicks = require('./incrementPhoneClicks');var _incrementPhoneClicks2 = _interopRequireDefault(_incrementPhoneClicks);
var _buyRocketPromotion = require('./buyRocketPromotion');var _buyRocketPromotion2 = _interopRequireDefault(_buyRocketPromotion);
var _findByNeighborhood = require('./findByNeighborhood');var _findByNeighborhood2 = _interopRequireDefault(_findByNeighborhood);
var _contactAgencyOnPropertyCreation = require('./contactAgencyOnPropertyCreation');var _contactAgencyOnPropertyCreation2 = _interopRequireDefault(_contactAgencyOnPropertyCreation);
var _myStaff = require('./myStaff');var _myStaff2 = _interopRequireDefault(_myStaff);
var _staff = require('./staff');var _staff2 = _interopRequireDefault(_staff);
var _native = require('./native');var _native2 = _interopRequireDefault(_native);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Import redux reducers
exports.default =
(0, _reduxLoop.combineReducers)({
  articles: _articles2.default,
  lang: _reduxPagan.i18n,
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  cities: _cities2.default,
  assetsToDelete: _assetsToDelete2.default,
  editCompanyByOwner: _editCompanyByOwner2.default,
  consultation: _consultation2.default,
  homePageProperties: _homePageProperties2.default,
  propertyTypes: _propertyTypes2.default,
  propertySearch: _propertySearch2.default,
  agencySearch: _agencySearch2.default,
  propertyPins: _propertyPins2.default,
  propertyDetails: _propertyDetails2.default,
  manageProperties: _manageProperties2.default,
  messageModal: _messageModal2.default,
  userAuthentication: _userAuthentication2.default,
  publishProperty: _publishProperty2.default,
  mobilesFilters: _mobilesFilters2.default,
  advancedFilters: _advancedFilters2.default,
  mobileHeader: _mobileHeader2.default,
  windowDimentions: _windowDimentions2.default,
  contactUs: _contactUs2.default,
  phoneSmsVerification: _phoneSmsVerification2.default,
  favoriteProperties: _favoriteProperties2.default,
  propertyNotes: _propertyNotes2.default,
  form: _reduxForm.reducer,
  reviewedPins: _reviewedPins2.default,
  realtor: _realtor2.default,
  company: _company2.default,
  reportIssues: _reportIssues2.default,
  propertiesAnalytics: _propertiesAnalytics2.default,
  saveSearchLocation: _saveSearchLocation2.default,
  myAccount: _myAccount2.default,
  professionals: _professionals2.default,
  projectProperties: _projectProperties2.default,
  payments: _payments2.default,
  shareModal: _shareModal2.default,
  suggestions: _receiveSuggestions2.default,
  discountCoupon: _discountCoupon2.default,
  searchAddressLocus: _searchAddressLocus2.default,
  similarProperties: _similarProperties2.default,
  placesGeocode: _placesGeocode2.default,
  notifications: _notifications2.default,
  subscriptions: _subscriptions2.default,
  upgradeRegularUserPackage: _upgradeRegularUserPackage2.default,
  recentSearches: _recentSearches2.default,
  propertyDetailedForm: _propertyDetailedForm2.default,
  foreignPropertyPageProperties: _foreignPropertyPageProperties2.default,
  foreignPropertySearch: _foreignPropertySearch2.default,
  countries: _countries2.default,
  otherCompanyProperties: _otherCompanyProperties2.default,
  leads: _leads2.default,
  buyMoreQuestions: _buyMoreQuestions2.default,
  contactUsClientForm: _contactUsClientForm2.default,
  contactFormModal: _contactFormModal2.default,
  creationNewHomes: _creationNewHomes2.default,
  myProjects: _myProjects2.default,
  foreignLimit: _feedbackIncreaseLimits2.default,
  incrementPhoneClicks: _incrementPhoneClicks2.default,
  buyRocketPromotion: _buyRocketPromotion2.default,
  companyFindByNeighborhood: _findByNeighborhood2.default,
  contactAgencyOnProperty: _contactAgencyOnPropertyCreation2.default,
  myStaff: _myStaff2.default,
  staff: _staff2.default,
  native: _native2.default }); // Modules
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 3054
// module chunks = 0